module.exports = __webpack_public_path__ + "img/thumb_aula32.f92bcf60.jpg";